export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtDokladdruh';
export const NAME = 'DruhDokladu';
